import { useRef, useState } from "react";

function CompanyAppAccessTableRow({key, appNames, handleSubmit, setError, t, setAdd, oddIdx }) {
	const today = new Date().toISOString().split("T")[0];
	const [appName, setAppName] = useState("");
	const [subscriptionDate, setSubscriptionDate] = useState("");
	const [isSubmit, setIsSubmit] = useState(false);
	let selectedApp = "";
	let selectedSubscriptionDate = "";
	const subscriptionDateRef = useRef(null);

	function appNameHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		selectedApp = e.target.value;
		setAppName(selectedApp);
	}
	
	function subscriptionDateHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		selectedSubscriptionDate = e.target.value;
		setSubscriptionDate(selectedSubscriptionDate);
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		setSubscriptionDate(subscriptionDateRef.current.value);
		let initialValues = {
			appName: appName,
			subscriptionDate: subscriptionDateRef.current.value
		};

		if (!appName) {
			setError(t("error.appName.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<select id="appName" onChange={(e) => (appNameHandler(e))} value={appName} className="form-select" style={{ minWidth: "15vw" }}>
					<option />
					{appNames.length > 0 && appNames.map((appNameObj, index1) => (
						(appNameObj.appName !== "Customer") &&
						<option
							value={appNameObj.appName}
						>
							{appNameObj.appDisplayName}
						</option>
					))}
				</select>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="date"
					name="subscriptionDate"
					id="subscriptionDate"
					value={subscriptionDate || today}
					min={today}
					className="form-control rounded-pill shadow-sm px-4 "
					ref={subscriptionDateRef}
					onChange={(e) => (subscriptionDateHandler(e))}
					style={{ maxWidth: "250px" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default CompanyAppAccessTableRow;